import ruDictionary from './ru';
import enDictionary from './en';

export default {
  ru_RU: ruDictionary,
  en_US: enDictionary,
};
